import { ToastManager } from '../../../ToastManager';

export function asStringArray(value: unknown): string[] {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter((item): item is string => {
    return typeof item === 'string' && item !== '';
  });
}

export function toastAdd(payload: { icon: unknown; message: string; iconColor?: string }): void {
  (
    ToastManager as unknown as {
      add: (value: { icon: unknown; message: string; iconColor?: unknown; i18n?: unknown }) => void;
    }
  ).add(payload);
}

export function normalize(value: unknown): string {
  if (typeof value === 'string') {
    return value.toLowerCase();
  }

  return '';
}

export function isMatch(value: unknown, query: string): boolean {
  if (query === '') {
    return true;
  }

  return normalize(value).includes(query);
}

export async function copyToClipboard({
  value,
  icon,
  message = 'Copied to clipboard.',
}: {
  value: string;
  icon: unknown;
  message?: string;
}): Promise<void> {
  await navigator.clipboard.writeText(value);
  toastAdd({
    icon,
    message,
  });
}
